'use client';

import React, { FC } from 'react';

import { ArrowLeftIcon } from '@abg/kit-base';

import { LocationGroupBackButton } from './GroupBackButton.styled';

interface GroupBackButtonProperties {
  label: string;
  onClick: () => void;
}

export const GroupBackButton: FC<GroupBackButtonProperties> = ({
  label,
  onClick,
  ...props
}) => {
  return (
    <LocationGroupBackButton
      startIcon={<ArrowLeftIcon />}
      onClick={onClick}
      {...props}
    >
      {label}
    </LocationGroupBackButton>
  );
};
